import { createFileRoute } from '@tanstack/react-router'
import RequestTicket from '@/features/request-ticket'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/request-ticket/')({
  component: RequestTicketRoute,
})

function RequestTicketRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.RequestSalaryTicketManage}>
      <RequestTicket />
    </ProtectedRoute>
  )
} 